import React from 'react';
import { DefaultPageBar, ShipmentPageBar, ProjectPageBar, LogPageBar } from './styles';
import { getAppBarHeight } from '#helper';

const viewComponents = {
  default: DefaultPageBar,
  shipment: ShipmentPageBar,
  project: ProjectPageBar,
  log: LogPageBar
};

const PageBar = props => {
  const { children, view = 'default', ...restProps } = props;
  const appBarHeight = getAppBarHeight();
  const Container = viewComponents[view] || DefaultPageBar;

  return (
    <Container
      style={{ top: appBarHeight }}
      {...restProps}
    >
      {children}
    </Container>
  );
};

export default PageBar;
